import { Link, TableCell, TableRow, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import StatusChip from "src/components/StatusChip";
import { formateDate } from "src/utils";

// ----------------------------------------------------------------------

PublicLinkTableRow.propTypes = {
  row: PropTypes.object,
  selected: PropTypes.bool,
};

export default function PublicLinkTableRow({ row, selected }) {
  const handleLinkClick = async (e) => {
    e.preventDefault();

    if (row.status === "inactive") {
      window.ToastError("Public link is expired. Generate a new link.");
      return;
    }

    handleCopyLink();
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(row.link);
    window.Toast("Link copied successfully!");
  };

  const truncateLink = (link, maxLength = 30) => {
    if (!link) return "-";
    return link.length > maxLength
      ? `${link.substring(0, maxLength)}...`
      : link;
  };

  return (
    <>
      <TableRow hover selected={selected}>
        <TableCell align="left">{row.title ?? "-"} </TableCell>
        <TableCell align="left">{row.type ?? "-"} </TableCell>
        <TableCell align="left">{row.program_code ?? "-"} </TableCell>
        <TableCell align="left">
          {row.link ? (
            <Tooltip
              title={
                row.status === "inactive"
                  ? "Link expired"
                  : "Click to copy link"
              }
            >
              <Link
                onClick={handleLinkClick}
                sx={{
                  color:
                    row.status === "inactive" ? "grey.500" : "primary.main",
                  cursor: row.status === "inactive" ? "not-allowed" : "pointer",
                  "&:hover": { textDecoration: "none" },
                }}
              >
                {truncateLink(row.link)}
              </Link>
            </Tooltip>
          ) : (
            "-"
          )}
        </TableCell>
        <TableCell align="left">
          {formateDate(row.expiryDate ?? "-")}{" "}
        </TableCell>
        <TableCell align="left">
          <StatusChip status={row.viewed} />
        </TableCell>
        <TableCell align="left">
          <StatusChip status={row.status} />{" "}
        </TableCell>

        <TableCell align="left">{row.user_name ?? "-"}</TableCell>
        <TableCell align="left">{formateDate(row.createdOn ?? "-")} </TableCell>
      </TableRow>
    </>
  );
}
